const filterItems = {
  CO: `
  query Filters {
    allApifilterItems {
      edges {
        node {
          city {
            component
            filter_type
            name
            data {
              city_label
              city_name
              id_city
              zones {
                label
                id_city
                name
              }
            }
          }
          inventory_type {
            component
            data
            filter_type
            name
          }
          price {
            component
            data {
              max
              min
            }
            filter_type
            name
          }
          room {
            component
            data
            filter_type
            name
          }
          bath {
            component
            data
            filter_type
            name
          }
          stratum {
            component
            filter_type
            data
            name
          }
          area {
            component
            filter_type
            name
            data {
              max
              min
            }
          }
          garage {
            component
            data
            filter_type
            name
          }
          has_elevator {
            component
            data
            filter_type
            name
          }
          pages {
            desktop_pages
            mobile_pages
          }
          metropolitan_area {
            alternative_id
            cities {
              alternative_id
              name
              label
              id_metropolitan_area
            }
            label
            name
          }
        }
      }
    }
  }
`,
  MX: `
  query Filters {
    allApifilterItems {
      edges {
        node {
          messagge {
            city {
              component
              data {
                city_label
                city_name
                id_city
                zones {
                  alternative_id
                  id_city
                  label
                  name
                }
              }
              filter_type
              name
            }
            property_moment {
              component
              data
              filter_type
              name
            }
            price {
              component
              data {
                max
                min
              }
              filter_type
              name
            }
            room {
              component
              data
              filter_type
              name
            }
            bath {
              component
              data {
                complete
                medium
              }
              filter_type
              name
            }
            area {
              data {
                max
                min
              }
              filter_type
              name
              component
            }
            garage {
              component
              data
              filter_type
              name
            }
            has_elevator {
              component
              data
              filter_type
              name
            }
            gatekeeper {
              component
              filter_type
              data
              name
            }
            pages {
              desktop_pages
              mobile_pages
            }
          }
        }
      }
    }
  }
`,
};

module.exports = { filterItems };
